import {jsx as _jsx, Fragment as _Fragment} from "react/jsx-runtime";import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'
import {useLocation} from 'react-router'

import useRouter from '../hooks/useRouter'
import NotificationAction from './NotificationAction'
import NotificationTemplate from './NotificationTemplate'





const RequestToJoinOrgNotification = (props) => {
  const {notification: notificationRef} = props
  const {history} = useRouter()
  const location = useLocation()
  const notification = useFragment(
    graphql`
      fragment RequestToJoinOrgNotification_notification on NotifyRequestToJoinOrg {
        ...NotificationTemplate_notification
        id
        name
        email
        picture
        requestCreatedBy
        domainJoinRequestId
      }
    `,
    notificationRef
  )
  const {name, email, picture, domainJoinRequestId} = notification

  const onActionClick = () => {
    history.replace(`/organization-join-request/${domainJoinRequestId}`, {
      backgroundLocation: location
    })
  }

  return (
    _jsx(_Fragment, { children: 
      _jsx(NotificationTemplate, {
        avatar: picture,
        message: `${name} has requested to join your organization`,
        action: _jsx(NotificationAction, { label: `Review ${email}`, onClick: onActionClick,} ),
        notification: notification,}
      )
    })
  )
}

export default RequestToJoinOrgNotification
